import { Asterisk } from "lucide-react";

const ITEMS = [
  { text: "The best website is the one you feel good sending people to.", display: true },
  { text: "Bespoke websites" },
  { text: "Clear thinking" },
  { text: "Careful craft" },
  { text: "No agency theatre" },
  { text: "Made carefully in the UK" },
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={
            item.display
              ? "whitespace-nowrap px-8 font-display text-3xl font-bold tracking-[-0.03em] text-[#201e32] sm:text-5xl"
              : "whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.28em] text-[#201e32]/70"
          }
        >
          {item.text}
        </span>
        <Asterisk size={item.display ? 30 : 16} className="shrink-0 text-[#7650c7]" aria-hidden />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-label="Studio beliefs"
    className="overflow-hidden border-y border-[#201e32]/15 bg-[#f4d35e] py-10 sm:py-14"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
